import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExit = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_362_6528)",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_362_6528",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 24,
			height: 24,
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "currentColor"
			})
		}), /* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_362_6528)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M5.70773 19.9001C5.25756 19.9001 4.87706 19.7447 4.56623 19.4338C4.25539 19.123 4.09998 18.7425 4.09998 18.2923V14.5348H5.39998V18.2923C5.39998 18.3693 5.43206 18.4398 5.49623 18.5038C5.56023 18.568 5.63073 18.6001 5.70773 18.6001H18.2922C18.3692 18.6001 18.4397 18.568 18.5037 18.5038C18.5679 18.4398 18.6 18.3693 18.6 18.2923V5.70785C18.6 5.63085 18.5679 5.56035 18.5037 5.49635C18.4397 5.43218 18.3692 5.4001 18.2922 5.4001H5.70773C5.63073 5.4001 5.56023 5.43218 5.49623 5.49635C5.43206 5.56035 5.39998 5.63085 5.39998 5.70785V9.46535H4.09998V5.70785C4.09998 5.25768 4.25539 4.87718 4.56623 4.56635C4.87706 4.25551 5.25756 4.1001 5.70773 4.1001H18.2922C18.7424 4.1001 19.1229 4.25551 19.4337 4.56635C19.7446 4.87718 19.9 5.25768 19.9 5.70785V18.2923C19.9 18.7425 19.7446 19.123 19.4337 19.4338C19.1229 19.7447 18.7424 19.9001 18.2922 19.9001H5.70773ZM10.973 16.2616L10.0442 15.3521L12.7462 12.6501H4.09998V11.3501H12.7462L10.0442 8.6481L10.973 7.7386L15.2345 12.0001L10.973 16.2616Z",
				fill: "currentColor"
			})
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_362_6528",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "currentColor"
		})
	}) })]
});
export default SvgExit;
